"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Factory_V1 = void 0;
const fork_1 = require("./transforms/fork");
const mut8_1 = require("./transforms/mut8");
const rel8_1 = require("./transforms/rel8");
const constants_1 = require("./constants");
class Factory_V1 {
    static root() {
        return Factory_V1.primitive({ ib: constants_1.IB });
    }
    static primitive({ ib }) {
        return { ib, gib: constants_1.GIB };
    }
    static primitives({ ibs }) {
        return ibs.map(ib => Factory_V1.primitive({ ib }));
    }
    static firstGen({ ib = constants_1.IB, parentIbGib = Factory_V1.root(), data, rel8ns, dna, tjp, linkedRel8ns, noTimestamp, nCounter, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const lc = `[firstGen]`;
            /** * Multiple transform steps will create multiple results. */
            const interimResults = [];
            let src = parentIbGib || constants_1.ROOT;
            let resFork = yield (0, fork_1.fork)({
                src,
                destIb: ib,
                tjp,
                dna,
                linkedRel8ns,
                noTimestamp,
                nCounter,
            });
            interimResults.push(resFork);
            src = resFork.newIbGib;
            if (data) {
                let resMut8 = yield (0, mut8_1.mut8)({
                    src,
                    dataToAddOrPatch: data,
                    dna,
                    linkedRel8ns,
                    noTimestamp,
                    nCounter,
                });
                interimResults.push(resMut8);
                src = resMut8.newIbGib;
            }
            ;
            if (rel8ns) {
                let resRel8 = yield (0, rel8_1.rel8)({
                    src,
                    rel8nsToAddByAddr: rel8ns,
                    dna,
                    linkedRel8ns,
                    noTimestamp,
                    nCounter,
                });
                interimResults.push(resRel8);
                // src = resRel8.newIbGib; // not needed because not used (this is the last step)
            }
            if (interimResults.length > 1) {
                const newIbGib = interimResults.slice(interimResults.length - 1)[0].newIbGib;
                const result = {
                    newIbGib,
                    intermediateIbGibs: interimResults.slice(0, interimResults.length - 1).map(x => x.newIbGib),
                };
                if (dna) {
                    let dnas = [];
                    interimResults.forEach(res => { dnas = dnas.concat(res.dnas); });
                    result.dnas = dnas;
                }
                return result;
            }
            else if (interimResults.length === 1) {
                // for some reason the caller just used this as a fork.
                return interimResults[0];
            }
            else {
                throw new Error(`${lc} hmm, I'm not sure...`);
            }
        });
    }
}
exports.Factory_V1 = Factory_V1;
